<div class="typing-spinner" *ngIf="isLoading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
</div>